import { StoryblokImage } from '@cinch-nx/data-storyblok'
import { HubCardSkeleton } from '@cinch-nx/landing-ui-shared'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { useRouter } from 'next/router'

import { ArticleCard } from '../article-card/article-card'
import styles from './articles-cards-list.module.css'

interface ArticlesCardsListProps {
  articles: {
    path: string
    title: string
    image: StoryblokImage
    date: string
  }[]
  page: number
  path: string
}

export const ArticlesCardsList: React.FC<ArticlesCardsListProps> = ({
  articles,
  path,
  page,
}) => {
  const { isFallback } = useRouter()
  const { trackEvent } = useAnalytics()
  const capitalPath = path.charAt(0).toUpperCase() + path.slice(1)

  const handleClick = (title: string) => {
    trackEvent({
      eventName: `${capitalPath}- click article card`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'link',
          label: title,
          action: EventNames.click,
        },
      },
    })
  }
  if (isFallback) {
    return (
      <div data-testid="skeletonPlaceHolder">
        {Array.from({ length: 10 }).map((_, idx) => (
          <HubCardSkeleton key={idx} featured={idx === 0} hasDate />
        ))}
      </div>
    )
  }

  return (
    <ul>
      {articles?.map((item, idx) => (
        <li className={styles['listItem']} key={item.title}>
          <a
            href={item.path}
            className={styles['link']}
            aria-label={item.title}
            onClick={() => handleClick(item.title)}
            data-testid="article-sub-hub-preview-card"
          >
            <ArticleCard
              title={item.title}
              image={item.image}
              date={item.date}
              featured={idx === 0 && page === 1}
            />
          </a>
        </li>
      ))}
    </ul>
  )
}
